import { ConnectTestCardBase } from "@app/provider/testData/testCard/connect/ConnectTestCardBase";

export class VistaraTestCard extends ConnectTestCardBase {}
